import { Constants } from './../../models/Constants';
import { element } from 'protractor';
import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, pipe } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoadingService } from '../../services/loading.service';
@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {
  private totalRequests:number=0;
  constructor(private loaderService: LoadingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.totalRequests=this.totalRequests+1;;


    //Get the API that dont required full page loader
    let elementLevelLoaderAPIs=Constants.ElementLevelLoaderAPIs();
    let loaderFlag=true;
    //IF the FULL URL have the request method as ControllerName/MethodName then: full loader page not requried
    elementLevelLoaderAPIs.forEach(item=>{
      if(req.url.includes(item)){
        loaderFlag=false;
      }
    })
    if(!req.url.includes('svg')&&loaderFlag){

      this.showLoader();
    }

    return next.handle(req).pipe(tap((event: HttpEvent<any>) => {

      if( this.totalRequests!=0){
        this.totalRequests=this.totalRequests-1;
      }

      if (event instanceof HttpResponse) {
        if(!req.url.includes('svg')){
          this.onEnd();
        }

      }
    },
      (err: any) => {

        if( this.totalRequests!=0){
          this.totalRequests=this.totalRequests-1;
        }
        if(!req.url.includes('svg')){
          this.onEnd();
        }

      }));
  }


  private onEnd(): void {
    if (this.totalRequests <= 0){
      this.hideLoader();
    }
  }
  private showLoader(): void {
    this.loaderService.show();


  }
  private hideLoader(): void {


      this.loaderService.hide();

    //this.loaderService.hide();
  }


}

